import { Component, OnInit } from '@angular/core';
import { StaticPagesService } from '../../../shared/services/static-page/static-pages.service';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { firstValueFrom, lastValueFrom } from 'rxjs';
import { RouterModule } from '@angular/router';
import { ImgViewComponent } from '../../../shared/components/img-view/img-view.component';
import { ActivatedRoute } from '@angular/router';
import { Meta, Title } from '@angular/platform-browser';
import { PLATFORM_ID, Inject } from '@angular/core';

@Component({
  selector: 'app-blog-detail',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, ImgViewComponent, RouterModule],
  templateUrl: './blog-detail.component.html',
  styleUrl: './blog-detail.component.scss'
})
export class BlogDetailComponent implements OnInit {
  constructor(private staticPagesService: StaticPagesService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private metaService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  blogDetail: any
  tags:string[]=[]

  async ngOnInit(): Promise<void> {
    const pageUrl = this.activatedRoute.snapshot.params['pageUrl'];
  
      // Hem server-side hem client-side'da API çağrısı yap
      const data = await firstValueFrom(this.staticPagesService.getBlogDetail(pageUrl));
      this.blogDetail = data;
      
      if(data.tag && data.tag !='') {
        this.tags = data.tag.split(',').map((item:any)=>item.trim());
      }
      
      this.titleService.setTitle(this.blogDetail.title ?? 'VizeAsist');
      this.metaService.updateTag({ name: 'description', content: this.blogDetail.metaDescription ?? '', });
      this.metaService.updateTag({ name: 'keywords', content: this.blogDetail.metaKeyword ?? '', });
  }
}
